export default __webpack_public_path__ + "53d2e04c7a33975851e2aa89b8afe430.svg";